<template>
  <div>
    <UserCtas :hide-user-cta="hideUserCta"
              @face-checkin-cta="$emit('face-checkin-cta')"
              v-if="hasGalleries"/>

    <template v-if="canSeeMedia">
      <MediaTabs @select="onSelectTab"/>
      <div>
        <UnlockedGalleries v-show="currentTab===checkinTabs.BOUGHT"
                           :galleries="unlockedGalleries"
                           :gallery-type="galleryTypes.UNLOCKED"
                           v-if="unlockedGalleries && unlockedGalleries.length > 0"/>

        <PaidGalleries v-show="currentTab===checkinTabs.BUYABLE"
                       :galleries="paidGalleries"
                       :gallery-type="galleryTypes.PAID"
                       v-if="paidGalleries && paidGalleries.length > 0"/>

        <FavoriteGalleries v-show="currentTab===checkinTabs.FAVORITE"
                           :galleries="favoriteGalleries"
                           :gallery-type="galleryTypes.FAVORITE"
                           v-if="favoriteGalleries && favoriteGalleries.length > 0"/>
      </div>
    </template>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import UnlockedGalleries from "@/domain/galleries/UnlockedGalleries.vue";
import {checkinTabs, galleryTypes} from "@/domain/galleries/constants";
import PaidGalleries from "@/domain/galleries/PaidGalleries.vue";
import MediaTabs from "@/domain/galleries/components/MediaTabs.vue";
import UserCtas from "@/domain/galleries/components/UserCtas.vue";
import FavoriteGalleries from "@/domain/galleries/FavoriteGalleries.vue";

export default {
  name: 'Galleries',
  emits: ['face-checkin-cta'],
  data() {
    return {
      currentTab: checkinTabs.BOUGHT,
    }
  },
  components: {
    FavoriteGalleries,
    UserCtas,
    MediaTabs,
    PaidGalleries,
    UnlockedGalleries,
  },
  props: {
    hideUserCta: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('checkinDetail', ['checkin', 'canSeeMedia']),
    ...mapGetters('galleries', [
      'galleries',
      'unlockedGalleries',
      'paidGalleries',
      'favoriteGalleries'
    ]),
    galleryTypes() {
      return galleryTypes
    },
    checkinTabs() {
      return checkinTabs
    },
    hasGalleries() {
      return Object.keys(this.galleries).length > 0
    }
  },
  async mounted() {
    this.resetGalleries()
    await this.load()
  },
  methods: {
    ...mapActions('galleries', [
      'fetchGalleries',
      'resetGalleries']),
    async load() {
      await this.fetchGalleries({
        checkin_id: this.checkin.id
      })
    },
    onSelectTab(tab) {
      this.currentTab = tab
      if (tab === checkinTabs.FAVORITE) {
        window.dispatchEvent(new Event('scroll'))
      }
    }
  },
  beforeDestroy() {
    this.resetGalleries()
  }
}

</script>
